import { acctExecutive } from "../api/accounting";
import { AcctShell } from "../features/acct/AcctShell";
import { StatTile } from "../features/acct/StatTile";
import { useCachedResource } from "../hooks/useCachedResource";

const TILES = [
  ["gross_margin_percent", "acct.exec.grossMargin"],
  ["net_margin_percent", "acct.exec.netMargin"],
  ["quick_ratio", "acct.exec.quickRatio"],
  ["return_on_assets_percent", "acct.exec.roa"],
  ["receivable_days", "acct.exec.receivableDays"],
  ["payable_days", "acct.exec.payableDays"],
  ["receivables", "acct.exec.receivables"],
  ["payables", "acct.exec.payables"],
];

export default function AcctExecutivePage() {
  const { data } = useCachedResource("acct-exec", () => acctExecutive({}).catch(() => null));

  return (
    <AcctShell titleKey="executive">
      {data ? (
        <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-4" data-testid="exec-tiles">
          {TILES.map(([key, label]) => (
            <StatTile key={key} testId={`exec-${key}`} labelKey={label} value={data[key]} />
          ))}
        </div>
      ) : null}
    </AcctShell>
  );
}
